import {Component, OnInit} from '@angular/core';
import {UnitEditModalComponent} from '../unit-edit-modal/unit-edit-modal.component';
import {ControlContainer, NgForm} from '@angular/forms';
import {SelectComponent} from '../../../core/components/edit-component';
import {UnitQuery, ClassificatorValuesQuery} from 'common-shared';

@Component({
  selector: 'mes-web-unit-select',
  templateUrl: './unit-select.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
  host: {class: "d-flex w-100 justify-content-center"},
  styles: [` :host {
    min-width: 10rem;
  }`]
})
export class UnitSelectComponent extends SelectComponent<UnitQuery> implements OnInit {

  constructor(public classificatorValuesQuery: ClassificatorValuesQuery) {
    super();
  }

  ngOnInit() {
  }

  addNewUnit(searchTerm: string = null) {
    this.modalService.show(UnitEditModalComponent, {initialState: {unitName: searchTerm} as UnitEditModalComponent}).onHide$.subscribe((bsModalRef) => {
      this.setEntityId(bsModalRef.content.unitId);
    });
  }

  editUnit() {
    this.modalService.show(UnitEditModalComponent, {initialState: {unitId: this.entityId} as UnitEditModalComponent}).onHide$.subscribe((bsModalRef) => {
      this.setEntityId(bsModalRef.content.unitId);
    });
  }
}
